import { render, staticRenderFns } from "./CustomerDetail6.vue?vue&type=template&id=62906292&scoped=true"
import script from "./CustomerDetail6.vue?vue&type=script&lang=js"
export * from "./CustomerDetail6.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail6.vue?vue&type=style&index=0&id=62906292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62906292",
  null
  
)

export default component.exports